<script lang="ts" setup>
import { type FontAwesomeIconProps } from '@fortawesome/vue-fontawesome';
import { FontAwesomeIcon } from '@shared/plugin/icons';
import { useSlots } from 'vue';

import VHeading from '@shared/typography/VHeading/VHeading.vue';

type Size = 'md' | 'xl';

const props = withDefaults(
  defineProps<{
    description?: string;
    icon: FontAwesomeIconProps['icon'];
    size?: Size;
    title: string;
  }>(),
  {
    size: 'md',
  },
);

const iconContainerClasses: Record<Size, string> = {
  md: 'size-[5.5rem] mb-6',
  xl: 'size-44 mb-8',
};

const slotContainerClasses: Record<Size, string> = {
  md: 'mt-6',
  xl: 'mt-8',
};

const slots = useSlots();
</script>

<template>
  <div class="mx-auto flex max-w-xl flex-col items-center justify-center">
    <div
      :class="[
        'flex items-center justify-center rounded-full bg-grey-accent-100',
        iconContainerClasses[props.size],
      ]"
    >
      <FontAwesomeIcon class="h-1/4 text-grey-accent-200" :icon="props.icon" />
    </div>

    <VHeading class="text-center" :level="2" appearance="xs">
      {{ props.title }}
    </VHeading>

    <p v-if="props.description" class="mt-4 max-w-xl text-center leading-normal text-primary-900">
      {{ props.description }}
    </p>

    <div v-if="slots.default" :class="slotContainerClasses[props.size]">
      <slot></slot>
    </div>
  </div>
</template>
